import api from "./axios";
import { paths } from "./paths";

export interface PlayerStat {
  id: string;
  name: string;
  wins: number;
  losses: number;
  draws: number;
  goals: number;
  assists: number;
  ownGoals: number;
  attendance: number;
  bonusPoints: number;
  efficiency: number;
}

export interface Summary {
  totalPlayers: number;
  totalMatches: number;
  totalGoals: number;
  goalsPerMatch: number;
}

export const getPlayerStats = () =>
  api.get<PlayerStat[]>(paths.statistics.players).then((r) => r.data);

export const getSummary = () =>
  api.get<Summary>(paths.statistics.summary).then((r) => r.data);
